// extracted by mini-css-extract-plugin
export default {"step1":"Step1_step1__Sg1Q0","values":"Step1_values__w+ICw","questions":"Step1_questions__-yVYH","tradeButtonContainer":"Step1_tradeButtonContainer__8NL11"};